<div class="representative-form">
  @for (rep of representatives.controls; track $index) {
    <div class="representative-form__item">
      @if (representatives.length > 1) {
        <button
          type="button"
          class="representative-form__item__remove"
          (click)="removeRepresentative($index)"
        >
          <aprova-icon name="trash-outline" size="sm" color="#dc2626" />
        </button>
      }

      <div class="representative-form__row representative-form__row--full" [formGroup]="$any(rep)">
        <aprova-input
          label="Nome completo"
          [control]="$any(rep).controls.nome"
          [errorMessages]="errorMessages"
        />
      </div>

      <div class="representative-form__row" [formGroup]="$any(rep)">
        <aprova-input
          label="CPF"
          [control]="$any(rep).controls.cpf"
          [errorMessages]="errorMessages"
          mask="000.000.000-00"
        />
        <aprova-input
          label="E-mail"
          inputType="email"
          [control]="$any(rep).controls.email"
          [errorMessages]="errorMessages"
        />
      </div>

      <div class="representative-form__row representative-form__row--full" [formGroup]="$any(rep)">
        <aprova-select
          label="Papel na empresa"
          [control]="$any(rep).controls.relacao"
          [selectOptions]="relacaoOptions"
          [errorMessages]="errorMessages"
          placeholder=""
        />
        @if (isRelacaoOutra($index)) {
          <aprova-input
            label="Descreva a relação"
            [control]="$any(rep).controls.outraRelacao"
            [errorMessages]="errorMessages"
          />
        }
      </div>
    </div>
  }

  <button
    type="button"
    class="representative-form__add"
    (click)="addRepresentative()"
  >
    + Adicionar outro representante
  </button>
</div>
